const fontVariantNumeric = {
  name: "font-variant-numeric",
  path: "/font-variant-numeric",
  title: "font-variant-numeric",
  description: "Utilities for controlling numeric font variants.",
  value: {
    "font-variant-numeric": {
      "normal-nums": "normal",
      "ordinal-nums": "ordinal",
      "slashed-zero-nums": "slashed-zero",
      "lining-nums": "lining-nums",
      "oldstyle-nums": "oldstyle-nums",
      "proportional-nums": "proportional-nums",
      "tabular-nums": "tabular-nums",
      "diagonal-fractions": "diagonal-fractions",
      "stacked-fractions": "stacked-fractions",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="normal-nums text-lg">1234567890 (normal)</p>
<p class="ordinal-nums text-lg">1st 2nd 3rd (ordinal)</p>
<p class="slashed-zero-nums text-lg">0 8 9 (slashed zero)</p>
<p class="lining-nums text-lg">1234567890 (lining)</p>
<p class="oldstyle-nums text-lg">1234567890 (oldstyle)</p>
<p class="proportional-nums text-lg">1234567890 (proportional)</p>
<p class="tabular-nums text-lg">1234567890 (tabular)</p>
<p class="diagonal-fractions text-lg">1/2 3/4 5/6 (diagonal fractions)</p>
<p class="stacked-fractions text-lg">1/2 3/4 5/6 (stacked fractions)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">normal-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">ordinal-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">slashed-zero-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">lining-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">oldstyle-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">proportional-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">tabular-nums</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">diagonal-fractions</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">stacked-fractions</code> to control numeric font variants:
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">normal-nums</small>
          <p class="normal-nums text-lg">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">ordinal-nums</small>
          <p class="ordinal-nums text-lg font-family-[Source_Sans_Pro]">1st 2nd 3rd</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">slashed-zero-nums</small>
          <p class="slashed-zero-nums text-lg font-family-[Source_Sans_Pro]">0 8 9</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">lining-nums</small>
          <p class="lining-nums text-lg font-family-[Source_Sans_Pro]">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">oldstyle-nums</small>
          <p class="oldstyle-nums text-lg font-family-[Source_Sans_Pro]">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">proportional-nums</small>
          <p class="proportional-nums text-lg font-family-[Source_Sans_Pro]">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tabular-nums</small>
          <p class="tabular-nums text-lg font-family-[Source_Sans_Pro]">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">diagonal-fractions</small>
          <p class="diagonal-fractions text-lg font-family-[Source_Sans_Pro]">1/2 3/4 5/6</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">stacked-fractions</small>
          <p class="stacked-fractions text-lg font-family-[Source_Sans_Pro]">1/2 3/4 5/6</p>
        </div>
      </div>
      `
    }
  ]
}
export default fontVariantNumeric;
 
<div class="space-y-6 sr-only">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">normal-nums</small>
          <p class="normal-nums text-lg">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">ordinal-nums</small>
          <p class="ordinal-nums text-lg font-family-[Source_Sans_Pro]">1st 2nd 3rd</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">slashed-zero-nums</small>
          <p class="slashed-zero-nums text-lg">0 8 9</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">lining-nums</small>
          <p class="lining-nums text-lg">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">oldstyle-nums</small>
          <p class="oldstyle-nums text-lg">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">proportional-nums</small>
          <p class="proportional-nums text-lg">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tabular-nums</small>
          <p class="tabular-nums text-lg">1234567890</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">diagonal-fractions</small>
          <p class="diagonal-fractions text-lg">1/2 3/4 5/6</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">stacked-fractions</small>
          <p class="stacked-fractions text-lg">1/2 3/4 5/6</p>
        </div>
      </div>